/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".filters[_ngcontent-%COMP%]{display:inherit}select[_ngcontent-%COMP%]{margin:0 2px}.filter-label[_ngcontent-%COMP%]{margin:8px 8px 0 0;color:#3d516f;font-weight:700}"];
export { styles as styles };
